import { action, observable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ImportValidationService } from 'application/import/services';
import { ImportService } from 'application/import/services';
import moment from 'moment';

@applicationContext
class ImportValidationModalStore extends BaseViewStore {
    @observable accessor items = [];
    @observable accessor facilityId = null;
    constructor(rootStore, componentProps) {
        const modalParams = componentProps.modalParams;
        const service = new ImportValidationService(rootStore.application.baasic.apiClient);
        super(rootStore)

        this.modalParams = modalParams;

        this.service = service;
        fetch([this.find()]);
        this.initializeWithImportHeader();
    }

    async find(){
        const modalData = this.modalParams.data && this.modalParams.data.item;
        const response = await this.service.find({
            embed:"CoreUser,Validation",
            patientGroupId: modalData.patientGroupId,
            importHeaderId: modalData.importHeaderId,
        });
        this.items = response.data.item;
    }

    @action.bound
    async initializeWithImportHeader() {
        const importService = new ImportService(this.rootStore.application.baasic.apiClient);
        const headerImport = await importService.get(this.modalParams.data.item.importHeaderId, { embed:"Facility" });
        this.facilityId = headerImport.data && headerImport.data.facility && headerImport.data.facility.id;
    }

    @action.bound
    onOpenPumps() {
        window.open(
            `${this.rootStore.routerStore.findRoute('master.app.main.pumps.landing').pattern}?facilityId=${this.facilityId}`
        )
    }

    @action.bound
    onChange(item) {
        item.isDone = !item.isDone;
        if(item.isDone){
            item.completedByUserId = this.rootStore.userStore.user.id;
            item.dateCompleted = moment();
        }
    }

    @action.bound
    async updateResource() {
        try {
            await this.service.bulkUpdate(this.items.map(x=>{
                return {
                    ...x,
                    coreUser:null
                }
            }));
            this.modalParams.close();   
            if (this.modalParams.data.item.fetch) {
                this.modalParams.data.item.fetch();
            }                     

            this.rootStore.notificationStore.success("Changes successfully updated.");
        }
        catch(err) {
            this.rootStore.notificationStore.error("Error occured while updateing.");
        }
    }
}

export default ImportValidationModalStore;